module.exports = __webpack_public_path__ + "img/sel__cupboard.01144857.svg";